<template>
  <div>
    <v-card class="mx-3 my-3">
      <v-toolbar flat height="auto" class="py-2">
        <v-row align="center" no-gutters class="ma-0" style="width: 100%">
          <v-col cols="12" md="3" lg="3">
            <v-text-field
              :value="search"
              placeholder="Buscar..."
              append-icon="search"
              dense
              clearable
              hide-details
              @input="$emit('update:search', $event)"
            />
          </v-col>
          <v-col cols="12" md="9" lg="9" class="pt-2 pt-md-0">
            <v-row
              no-gutters
              class="justify-center justify-md-end"
              style="column-gap: 8px; row-gap: 8px"
            >
              <v-col cols="12" sm="auto">
                <v-btn
                  block
                  class="px-2 text-white text-capitalize"
                  color="botonRefrescar"
                  dark
                  @click="$emit('refrescar')"
                >
                  <v-icon>refresh</v-icon>
                  Refrescar
                </v-btn>
              </v-col>
              <v-col v-if="puedeRegistrarEmpleado" cols="12" sm="auto">
                <v-btn
                  block
                  class="px-2 text-white text-capitalize"
                  color="primary"
                  dark
                  @click="$emit('register-click')"
                >
                  <v-icon>add</v-icon>
                  Registrar Empleado
                </v-btn>
              </v-col>
              <v-col cols="12" sm="auto">
                <v-btn
                  block
                  class="px-2 white--text text-capitalize"
                  color="primary"
                  depressed
                  :disabled="!tieneData"
                  @click="$emit('excel-descargar')"
                >
                  <v-icon>file_download</v-icon>
                  Descargar Archivo Excel
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-divider />

      <v-card-text class="pa-0">
        <TablaEmpleados
          v-if="tablaEstaVisible"
          :cargando="cargando"
          :empleados="listaEmpleados"
          :termino-busqueda="search"
          :puede-ver-salario="puedeVerSalario"
          :tiene-multiples-empresas="datosUsuario.empresas?.length > 0"
          @edit-item="$emit('edit-item', $event)"
          @ver-cartera="$emit('ver-cartera', $event)"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import TablaEmpleados from '../Table/TablaEmpleados.vue';

export default {
  name: 'EmpleadosTab',

  components: {
    TablaEmpleados,
  },

  props: {
    search: {
      type: String,
      default: '',
    },
    tablaEstaVisible: {
      type: Boolean,
      default: true,
    },
    listaEmpleados: {
      type: Array,
      default: () => [],
    },
    datosUsuario: {
      type: Object,
      default: () => ({}),
    },
    puedeVerSalario: {
      type: Boolean,
      default: false,
    },
    puedeRegistrarEmpleado: {
      type: Boolean,
      default: false,
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    tieneData() {
      return this.listaEmpleados.length > 0;
    },
  },
};
</script>
